import React from "react";

const ImagesCarouselComponent = (props) => {
  const { Renderer } = props;

  return <Renderer {...props} />;
};

export default ImagesCarouselComponent;
